import './utils/flexible';
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/mobile.css';
import MobileCardList from './components/MobileCardList.vue';
import App from './App.vue';
import router from './router';

Vue.use(ElementUI);
Vue.component('MobileCardList', MobileCardList);
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
